import React from "react"
import {
	Grid,
	Typography
} from "@material-ui/core"
import {
	Description as FileIcon,
	KeyboardVoice as AudioIcon,
	Image as PictureIcon,
	Videocam as VideoIcon,
	Person as ContactCardIcon
} from "@material-ui/icons"

import { Divider } from "@/components"
import { getContactCardDescription } from "@/components/Messages/ContactCardMessage"

import { IMessageExtraData, MessageType } from "@/protocols/channel"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/MessageList/MessageContentPlaceholder/styles"
import useCustomStyles from "@/styles/custom"

type MessageContentPlaceholderProps = {
	type: MessageType
	content?: string
	caption?: string
	className?: string
	extraData?: IMessageExtraData
}

const MessageContentPlaceholder: React.FC<MessageContentPlaceholderProps> = (props) => {
	const { type, caption, className, extraData, content } = props

	const classes = useStyles()
	const customClasses = useCustomStyles()

	const getSummaryIcon = () => {
		if (type === "file") {
			return <FileIcon fontSize="small" />
		} else if (type === "audio") {
			return <AudioIcon fontSize="small" />
		} else if (type === "picture") {
			return <PictureIcon fontSize="small" />
		} else if (type === "video") {
			return <VideoIcon fontSize="small" />
		} else if (type === "contact-card") {
			return <ContactCardIcon fontSize="small" />
		} else {
			return null
		}
	}

	const summaryIcon = getSummaryIcon()

	return (
		<Grid
			container
			wrap="nowrap"
			alignItems="center"
			className={className}
		>
			{summaryIcon && (
				<>
					{summaryIcon}

					<Divider orientation="vertical" size={0.5} />
				</>
			)}

			<Typography
				variant="overline"
				color="textPrimary"
				className={`${classes.text} ${customClasses.inlineText}`}
			>
				{caption || (
					<>
						{type === "file" && "Arquivo"}
						{type === "audio" && "Áudio"}
						{type === "picture" && "Foto"}
						{type === "video" && "Vídeo"}
						{type === "contact-card" && getContactCardDescription(extraData as IMessageExtraData)}
						{type === "button" && content}
						{type === "menu" && content}
					</>
				)}
			</Typography>
		</Grid>
	)
}

export default MessageContentPlaceholder
